<template>
  <detra-modal class="show-task-modal" :sidebar="true" :show="show_modal" @hide="hide()">
    <div class="p-24 pb-0">
      <div class="flex align-items-center">
        <div class="heading-medium">
          <skeleton-text :until="task">
            <div v-if="task">{{ task.name }}</div>
          </skeleton-text>
        </div>
        <dot-button v-if="task && task.project && this.$root.canEditBilledProjects(task.project.is_billed)">
          <div class="dropdown-button" @click="editTask()">Edit task</div>
          <div class="dropdown-button" @click="deleteTask()">Delete task</div>
        </dot-button>
      </div>
      <div class="text-strong text-capitalize color-gray-500">
        <skeleton-text :until="task">
          <div v-if="task">{{ task.type }} task</div>
        </skeleton-text>
      </div>
    </div>
    <div class="dm-content">
      <div class="flex">
        <div class="flex-grow-1">
          <div class="text-strong">Project</div>
          <div class="heading-small">
            <skeleton-text :until="task">
              <div v-if="task && task.project" style="max-width: 20rem;">{{ task.project.name }}</div>
            </skeleton-text>
          </div>
        </div>
        <div class="flex-grow-1">
          <div class="text-strong">Planned hours</div>
          <div class="heading-small">
            <skeleton-text :until="task">
              <div v-if="task">{{ $root.formatIntegerSecondsToReadable(task.duration, true) }}</div>
            </skeleton-text>

          </div>
        </div>
        <div class="flex-grow-1">
          <div class="text-strong">Tags</div>
          <skeleton-text :until="task">
            <div v-if="task && task.tag">
              <div class="tag">{{ task.tag.name }}</div>
            </div>
          </skeleton-text>
        </div>
      </div>
      <div>
        <div class="flex w-100 mt-4" v-if="!show_done_for_this_day">
          <div class="flex-grow-1 btn btn-secondary" @click="showProject()" v-skeleton-button="!task" v-if="task && task.type == 'client'">Go to project details</div>
          <div class="flex-grow-1 ml-3 btn btn-jet" @click="toggleDoneForThisDayForm(true)" v-skeleton-button="!task" v-show="task && !task.done" v-if="task && task.project && this.$root.canEditBilledProjects(task.project.is_billed)">
            Mark as done
          </div>
        </div>
        <div class="flex align-items-end w-100" v-if="show_done_for_this_day">
          <div class="w-100 p-8">
            <div class="btn btn-silent w-100" @click="toggleDoneForThisDayForm(false)">Cancel</div>
          </div>
          <div class="w-100 p-8">
            <div class="text-strong">Hours worked</div>
            <div class="mt-1 flex align-items-center">
              <input type="text" v-model="hours_worked" class="form-control">
            </div>
          </div>
          <div class="w-100 p-8">
            <div class="btn btn-jet w-100" @click="done()">Done</div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="p-24">
      <div class="heading-medium">Agenda details</div>
      <skeleton-text :until="task">
        <table class="w-100 mt-16 agenda-details-table" v-if="task">
          <tr>
            <th>Date in agenda</th>
            <th>Assignee</th>
            <th>assigned / completed hours</th>
          </tr>
          <tr v-for="assignation in task.assignations">
            <td>{{ assignation.date_formatted }}</td>
            <td v-if="assignation.user">{{ assignation.user.name }}</td>
            <td>
              <span>{{ assignation.duration_formatted }} / {{ assignation.completed_hours_formatted }}</span>
              <span class="check-circle" v-if="assignation.done">
                  <i class="fas fa-check"></i>
                </span>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td class="font-weight-bold">
              {{ _total_assigned_hours }} / {{ _total_completed_hours }}
            </td>
          </tr>
          <!--          <tr>-->
          <!--            <td colspan="3" class="text-right">-->
          <!--            <span class="text-strong color-gray-500">-->
          <!--              Predicted hours assigned:-->
          <!--              <skeleton-text :until="task">-->
          <!--                <div v-if="task">{{ _total_assigned_hours }} / {{ task.duration_formatted }}</div>-->
          <!--              </skeleton-text>-->
          <!--            </span>-->
          <!--            </td>-->
          <!--          </tr>-->
        </table>
      </skeleton-text>
    </div>

    <div>
      <div class="divider mt-24"></div>
      <skeleton-text :until="task" block="true">
        <div class="p-24">
          <div class="heading-medium mb-3">Description</div>
          <div class="text-strong" v-html="task && task.description ? task.description.replace(/(?:\r\n|\r|\n)/g, '<br>') : 'No description.'"></div>
        </div>
      </skeleton-text>
    </div>

    <div class="divider"></div>
    <div class="p-24">
      <div class="heading-medium">Comments</div>
      <!--      <skeleton-text :until="task">-->
      <!--        <div v-if="task">-->
      <!--          <div v-for="comment in task.comments" v-if="comment.log === 0">-->
      <!--            <div class="mt-3">-->
      <!--              <span class="heading-small">{{ comment.user.name }}</span>-->
      <!--              <span class="text-strong color-gray-500">{{ comment.created_at_human }}</span>-->
      <!--            </div>-->
      <!--            <div>{{ comment.comment }}</div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </skeleton-text>-->
      <div class="flex mt-16">
        <input @keyup.enter="postComment()" v-model="comment_text" type="text" class="form-control flex-grow-1 mr-4" placeholder="Add comment..." v-skeleton-input="!task">
        <div class="btn btn-secondary" @click="postComment()" v-skeleton-button="!task">Post</div>
      </div>
    </div>
    <template slot="sidebar">
      <task-sidebar :task="task"></task-sidebar>
    </template>
  </detra-modal>
</template>
<script>
import TaskSidebar from './task-sidebar'
import DotButton from './../../../components/dot-button'

export default {
  components: {
    TaskSidebar,
    DotButton,
  },
  created() {
    this.$root.$on('TaskModal::show-task', ({parent_id, task_id, row, col, callback}) => {
      this.task = null
      this.show()
      callback && callback()

      this.row = row
      this.col = col
      this.task_id = task_id || parent_id
      this.parent_id = parent_id
      this.show_done_for_this_day = null

      this.axios.get('/n/tasks/' + (parent_id || task_id)).then(response => {
        this.task = response.data.data
      })
    })
  },
  data() {
    return {
      task_id: null,
      parent_id: null,
      show_modal: false,
      task: null,
      row: null,
      col: null,
      comment_text: null,
      hours_worked: null,
      show_done_for_this_day: null,
    }
  },
  computed: {
    _total_assigned_hours() {
      let hours = 0
      _.each(this.task.assignations, a => hours += a.duration)
      return this.$root.formatIntegerSecondsToReadable(hours, true)
    },
    _total_completed_hours() {
      let hours = 0
      _.each(this.task.assignations, a => hours += a.completed_hours)
      return this.$root.formatIntegerSecondsToReadable(hours, true)
    },
  },
  methods: {
    show() {
      this.show_modal = true
    },
    hide() {
      this.show_modal = false
    },
    editTask() {
      this.$root.$emit('TaskModal::edit-task', {task_id: this.task_id, row: this.row, col: this.col}, () => {
        this.hide()
      })
    },
    deleteTask() {
      if (!confirm('Are you sure?')) return

      this.axios.delete('/n/tasks/' + this.task_id).then(response => {
        this.$root.$emit('Tasks::deleted', {task: this.task})
        _.each(this.task.children, child => {
          this.$root.$emit('Tasks::deleted', {task: child})
        })
        this.hide()
      }).catch(err => {
        console.log(err)
      })
    },
    postComment() {
      if (!this.comment_text || this.comment_text == '') return

      this.axios.post('/n/tasks/' + this.task_id + '/comment', {
        comment: this.comment_text,
      }).then(response => {
        let comment = response.data.data
        comment.log = 0
        this.task.comments = _.reverse(this.task.comments)
        this.task.comments.push(comment)
        this.task.comments = _.reverse(this.task.comments)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.comment_text = null
      })
    },
    showProject() {
      this.$root.$emit('ProjectModal::show-project', {project_id: this.task.project_id}, () => {
        this.hide()
      })
    },
    toggleDoneForThisDayForm(show) {
      this.show_done_for_this_day = show
      if (show) {
        this.hours_worked = this.$root.formatIntegerSecondsToReadable(this.task.duration)
      }
      if (!show) {
        this.hours_worked = null
      }
    },
    done() {
      this.axios.post('/n/tasks/' + this.task.id + '/done', {
        hours_worked: this.hours_worked,
        entire_task_done: true,
      }).then(response => {
        let tasks = response.data.data
        _.each(tasks, task => {
          this.$root.$emit('Tasks::updated', {task})
        })
        this.hide()
      })
    },
  }
}
</script>
<style lang="scss">

.check-circle {
  background: #37BB64;
  border-radius: 100%;
  color: white;
  padding: 0 5px 1px 4px;


  .fas {
    font-size: 8px;
  }
}

.agenda-details-table {
  tr {
    td, th {
      padding: 12px;

      &:first-child {
        padding-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-modal/show-task.vue